import styled from 'styled-components';
import { ITheme } from '../../../../../styles/theme';

interface IContentElem {
  theme: ITheme;
  isUnstyled?: boolean;
}

export const ContentElem = styled.div<IContentElem>`
  display: flex;
  width: 100%;
  gap: 24px;

  ${({ theme, isUnstyled }) => `
    flex-flow: column nowrap;
    padding: ${!isUnstyled ? `${theme.layout.spacing.deka} ${theme.layout.spacing.mega}` : '0'};
    background: ${!isUnstyled ? theme.colors.neutral.primary[5] : 'transparent'};
    border-radius: 8px;
    box-shadow: ${!isUnstyled ? `0px 1px 1px ${theme.colors.neutral.primary[40]}` : 'none'};

    @media (${theme.layout.breakpoints.max.tablet}) {
      padding: ${!isUnstyled ? `${theme.layout.spacing.centy} ${theme.layout.spacing.decy}` : '0'};
      gap: 16px;
    }
  `};
`;
